import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PipeSpecificationCodes, PipeSpecs } from 'src/app/Modules/settings/models/idms/pipe-specification.model';

@Component({
    selector: 'app-add-combination',
    templateUrl: './add-combination.component.html',
    styleUrls: ['./add-combination.component.scss'],
    standalone: false
})
export class AddCombinationComponent implements OnInit {
    @Input() selectedPipeCode: PipeSpecificationCodes;
    @Input() tittle: string;
    @Input() pipeSpecCombination: PipeSpecs;
    @Input() mode: string;

    addPipeSpecCombinationForm: UntypedFormGroup;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit(): void {
        this.createFormControls();
    }

    createFormControls() {
        const hasName = !!this.pipeSpecCombination?.name;

        this.addPipeSpecCombinationForm = this.formBuilder.group({
            CombinationName: [this.pipeSpecCombination?.name || null, Validators.required],
            CalculationType: [null],
            PermitWashers: [null],
        });

        const calcTypeControl = this.addPipeSpecCombinationForm.get('CalculationType');

        if (!hasName) {
            calcTypeControl?.setValidators(Validators.required);
            calcTypeControl?.updateValueAndValidity();
        } else {
            this.addPipeSpecCombinationForm.markAsPristine();
            this.addPipeSpecCombinationForm.markAsUntouched();
        }
    }

    addButtonClick() {
        this.ngbActiveModal.close(this.addPipeSpecCombinationForm.value);
    }

    closeClick() {
        this.ngbActiveModal.close(false);
    }
}
